import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {DateControllerDirective} from "./date-controller.directive";
import {DateControllerStateDirective} from "./date-controller-state.directive";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    DateControllerDirective,
    DateControllerStateDirective
  ],
  exports: [
    DateControllerDirective,
    DateControllerStateDirective
  ]
})
export class DateControllerModule {}
